import React, { useEffect, useState } from "react";
import { ResponseInterface } from "../../../interfaces/ResponseInterface";
import QLoading from "../../../common/components/QLoading";
import { UseSecondLayout } from "../../../context/LayoutContext";
import QModal from "../../../common/components/QModal";
import SetupApi from "../../../common/api/functions/Setup";
import BodyEconomicComponent from "./components/BodyEconomicComponent";
import { SetupInterface } from "../../../interfaces/private/SetupInterface";
import { config } from "../../../config";
import { QHelpers } from "../../../common/helpers";
// @ts-ignore
import { CopyToClipboard } from 'react-copy-to-clipboard';
import styles from "../../public/Setup/index.module.css";
import QIconCheck from "../../../common/components/QIcon/QIconCheck";
import { useTranslation } from "react-i18next";
import BodyLayoutComponent from "./components/BodyLayoutComponent";
import BodyPensopayComponent from "./components/BodyPensopayComponent";


export function Economic() {
    interface Layout {
        layoutNumber: number,
        name: string
    }
    const { t } = useTranslation();
    const [setup, setSetup] = useState<SetupInterface>({});
    const [loading, setLoading] = useState(true);
    const [createNewClick, setCreateNewClick] = useState(false);
    const [createNewLayoutClick, setCreateNewLayoutClick] = useState(false);
    const [copied1, setCopied1] = useState(false);
    const [copied2, setCopied2] = useState(false);
    const [copied3, setCopied3] = useState(false);
    const [copied5, setCopied5] = useState(false);
    const [createNewPensopayClick, setCreateNewPensopayClick] = useState(false);
    const [layouts, setLayouts] = useState([]);

    // Mask API key showing only last 3 characters
    const maskApiKey = (apiKey: string): string => {
        if (!apiKey || apiKey.length <= 3) return apiKey;
        const lastThree = apiKey.slice(-3);
        const maskedPart = '*'.repeat(Math.min(apiKey.length - 3, 20)); // Limit masked part to 20 chars for display
        return maskedPart + lastThree;
    };


    UseSecondLayout();
    useEffect(() => {
        if (loading) {
            load().then(async () => {
                await setLoading(false);

                let objectParams = QHelpers.object.convertParamUrlToObject(window.location.search)

                if (objectParams?.token) {
                    await setSetup({
                        ...setup,
                        eco_token: objectParams?.token,
                    })
                    await setCreateNewClick(true);
                }
            });
            loadLayout().then(async () => {
                await setLoading(false);
            });
        }
    }, [loading])

    const load = async () => {
        try {
            await SetupApi.detail().then(async (response: ResponseInterface | any) => {
                if (response?.status === config.STATUS_CODE.OK) {
                    setSetup(
                        response?.data?.data || {}
                    )
                }
            })

        } catch (err) {
        }
        if (loading) {
            await setLoading(false);
        }
    }

    const loadLayout = async () => {
        try {
            await SetupApi.getLayout().then(async (response: ResponseInterface | any) => {
                if (response?.status === config.STATUS_CODE.OK) {
                    console.log(response?.data.data);

                    setLayouts(
                        response?.data?.data || {}
                    )
                }
            })

        } catch (err) {
        }
        if (loading) {
            await setLoading(false);
        }
    }
    let getNameLayout = (layouts: any, number: number) => {
        if (layouts.length === 0) {
            return null;
        }
        let arrayObject = layouts.filter((l: any) => l.layoutNumber == number);
        let object: Layout = arrayObject[0];
        return object ? object.name : '';
    }
    return (
        <React.Fragment>
            <QModal
                open={createNewClick}
                setOpen={setCreateNewClick}
                headerContent={t("economic.title")}
                bodyContent={(
                    <BodyEconomicComponent
                        model={setup}
                        setOpen={setCreateNewClick}
                        setSetup={setSetup}
                        setLoadingFunc={setLoading}
                    />
                )}
            />
            <QModal
                open={createNewLayoutClick}
                setOpen={setCreateNewLayoutClick}
                headerContent={"Layout"}
                bodyContent={(
                    <BodyLayoutComponent
                        model={setup}
                        setOpen={setCreateNewLayoutClick}
                        setSetup={setSetup}
                        setLoadingFunc={setLoading}
                    />
                )}
            />
            <QModal
                open={createNewPensopayClick}
                setOpen={setCreateNewPensopayClick}
                headerContent={"Pensopay"}
                bodyContent={(
                    <BodyPensopayComponent
                        model={setup}
                        setOpen={setCreateNewPensopayClick}
                        setSetup={setSetup}
                        setLoadingFunc={setLoading}
                    />
                )}
            />
            <div className="col-md-10 relative">
                <QLoading loading={loading} />
                <div className="row ">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <div className="page-title-name">{'Api keys & tokens'}</div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="business-detail bg-orange-bland-zp bdr-20 pd-25">
                                <div className="row">
                                    <div className="col-md-8">
                                        <h2 className="fw-bold fs-24 mb-2">{'E-conomic token'}</h2>
                                    </div>
                                    <div className="col-md-4 text-end">
                                        <a className={""} href="#" data-bs-toggle="modal"
                                            data-bs-target="#showModalBusinessDetail"><i
                                                className="las la-pen fs-24 cl-br-ams ml-2"
                                                onClick={() => {
                                                    setCreateNewClick(true);
                                                }}
                                            /></a>
                                    </div>
                                </div>
                                <div className="row">
                                    <p className="mb-1">{setup.eco_token}</p>
                                </div>
                                {/* <div className="row">
                                    <div className="col-md-12 mb-2"><a href={QHelpers.string.generateUrlEconomic()}>{t("economic.generateNewToke")}</a></div>
                                </div> */}

                            </div>
                        </div>
                        <div className="col-lg-12" style={{marginTop: '20px'}}>
                            <div className="business-detail bg-orange-bland-zp bdr-20 pd-25">
                                <div className="row">
                                    <div className="col-md-8">
                                        <h2 className="fw-bold fs-24 mb-2">{'Pensopay api key'}</h2>
                                    </div>
                                    <div className="col-md-4 text-end">
                                        <a className={""} href="#" data-bs-toggle="modal"
                                            data-bs-target="#showModalBusinessDetail"><i
                                                className="las la-pen fs-24 cl-br-ams ml-2"
                                                onClick={() => {
                                                    setCreateNewPensopayClick(true);
                                                }}
                                            /></a>
                                    </div>
                                </div>
                                <div className="row">
                                    <p className="mb-1">{setup.pensopay_api_key ? maskApiKey(setup.pensopay_api_key) : 'n/a'}</p>
                                </div>
                                {/* <div className="row">
                                    <div className="col-md-12 mb-2"><a href={QHelpers.string.generateUrlEconomic()}>{t("economic.generateNewToke")}</a></div>
                                </div> */}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

// @ts-ignore
export default React.memo(Economic);
